<div class="xux-tabs-header">
  <div class="xux-tabs-item active"
       (click)="setTab('from')"
       [class.active]="activeTab === 'from'">
    <span>{{staticTextContent.from}}</span>
    {{tabValues.from.date || staticTextContent.selectFrom}}
  </div>
  <div class="xux-tabs-item"
       (click)="tabValues.from.date && setTab('to')"
       [class.active]="activeTab === 'to'"
       [class.disabled]="!tabValues.from.date">
    <span>{{staticTextContent.to}}</span>
    {{tabValues.to.date || staticTextContent.selectTo}}
  </div>
</div>

<div class="xux-tabs-body">
  <bs-daterangepicker-inline
          [bsValue]="_bsValue"
          [bsConfig]="dpConfig"
          [datesDisabled]="config.disabledDates"
          [minDate]="minDate"
          [maxDate]="config.maxDate"
          [isDisabled]="!isEditable()"
          [dateCustomClasses]="customClasses"
          (bsValueChange)="onValueChange($event)"
  ></bs-daterangepicker-inline>

</div>

<ul #monthSelector [class.hidden]="!showDropdown.month">
  <li *ngFor="let month of months"
      (click)="showMonth(month.number)"
      [class.disabled]="isDateDisabled(DateGranularity.MONTH, month.number)">
    {{month.name}}
  </li>
</ul>

<ul #yearsSelector [class.hidden]="!showDropdown.year">
  <ng-container *ngFor="let year of years">
    <li (click)="showYear(year)"
        *ngIf="!isDateDisabled(DateGranularity.YEAR, year)">
      {{year}}
    </li>
  </ng-container>
</ul>

<span
  #dayTooltipContainer
  *ngIf="config && config.dayTooltipTitles"
  [tooltip]="dayTooltipTitle"
  class="tooltip-target"
></span>
